import classNames from 'classnames';
import 'lazysizes';
import { isProduction } from 'helpers/authentication';
import Analytics from 'ui/design-base/Analytics';

export const TennistalkerBanner = ({
  imageUrl,
  destination,
  className,
}: {
  imageUrl: string;
  destination: string;
  className?: string;
}) => (
  <div className='mb-5'>
    <img
      data-sizes='auto'
      src={!isProduction() ? '/images/banner_placeholder.jpg' : imageUrl}
      className={classNames(className, 'lazyload', {
        'aspect-[27/9] w-full': !isProduction(),
      })}
      alt='image'
      onError={(e) => {
        if (!isProduction()) {
          e.currentTarget.src = '/images/banner_placeholder.jpg';
          e.currentTarget.classList.add('aspect-[27/9]');
        }
      }}
      onClick={() => {
        Analytics.sendEvent({ category: 'Promotion', action: 'Banner Click', label: destination });
        window.open(destination, '_blank');
      }}
    />
  </div>
);
export default TennistalkerBanner;
